import React, { Children,useEffect, useState, useRef } from 'react'
import { updateToolSettings,getToolSettings} from "../API";
import _forOwn from 'lodash/forOwn'
import _ from 'lodash'
import HelperService from '../Helpers/HelperService'
// import { useFocusEffect } from '@react-navigation/native'
import { sensorLive, channelColors, toolSyncTime,Colors, Helpers, Metrics, Spacing } from '../global'
import { View, Text, Button, Dashboard, Alert, Row, Icon, Graph  } from '../Components'
import { Row as ViewRow } from 'antd'
// import NavigationService from 'App/Services/NavigationService'
import {ReactComponent as toolIcon} from '../Assets/SVG/Analog_Big.svg'
// import { getAllGraphData } from 'App/Stores/Tools/Selectors'
import {ReactComponent as ch1Icon} from '../Assets/SVG/Ch1.svg'
import {ReactComponent as ch2Icon} from '../Assets/SVG/Ch2.svg'
import {ReactComponent as ch3Icon} from '../Assets/SVG/Ch3.svg'
import {ReactComponent as ch4Icon} from '../Assets/SVG/Ch4.svg'
import {ReactComponent as unitIcon} from '../Assets/SVG/Unit_Small.svg'
import {ReactComponent as powerIcon} from '../Assets/SVG/Power_Small.svg'
import {ReactComponent as sensorIcon} from '../Assets/SVG/SensorType.svg'
import {ReactComponent as sensorPowerIcon} from '../Assets/SVG/SensorPower.svg'
import {ReactComponent as scalingIcon} from '../Assets/SVG/Scaling.svg'
import {ReactComponent as infoIcon} from '../Assets/SVG/Info.svg'
import { allSitesAtom } from "../Atoms/allSitesAtom"//"./Atoms/allSitesAtom";
import { useRecoilState } from "recoil";
import { useAuthenticator } from '@aws-amplify/ui-react'

const styles = {
  dashboardView: {
    flexGrow: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  dashboardValue: {
    width: '50%'
  },
  overviewValue: {
    width: '100%',
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom:Spacing.md
  },
  symbolContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingBottom:Spacing.md,
    marginTop:Spacing.xm,
    ...Metrics.horizontalMargin
  },
}

const analogProbeType = [
    "Adapter 0-3.3V",
    "Adapter 0-5V",
    "Adapter 0-10V",
    "Adapter 0-24V",
    "Adapter 4-20mA",
]

const SA4C = ({ children }) => (
    <View>
    {Children.map(children, (child, i) => {
      return <View key={i}>{child}</View>
    })}
  </View>
)

export const SA4C_CH_ENUM =
    [
        "sa4c_vC1",
        "sa4c_vC2",
        "sa4c_vC3",
        "sa4c_vC4"
    ]

export const SA4C_CHANNEL_ICONS = [ch1Icon,ch2Icon,ch3Icon,ch4Icon]

export const SA4C_DEFAULT_Y_AXIS = (channels)=>{
  let tempYArray = []
  SA4C_CH_ENUM.forEach(channel => {
    if(channels[channel]?.enabled){
      let tempUnit = channels[channel].linearScalingEnable?(channels[channel].linearScalingUnit):(channels[channel].unit)
      let temp = {enabled:true,name:channels[channel].sensorType + ' Axis (' + tempUnit + ')',channels:[_.findIndex(SA4C_CH_ENUM, function(o) { return o == channel; })],auto:true,min:0,max:100}
      let tempIndex = _.findIndex(tempYArray, function(o) { return o.name == temp.name})
      if( tempIndex == -1){
        tempYArray = _.concat(tempYArray, temp)
      }else{
        tempYArray[tempIndex].channels = _.concat(tempYArray[tempIndex].channels,_.findIndex(SA4C_CH_ENUM, function(o) { return o == channel; }))
      }
    }
  })
  return tempYArray
}

export const SA4C_ENABLED_CHANNELS= (tool,addTS) =>{
  let enabledChannels = []
  if(addTS) enabledChannels.push("ts")
  if(tool.settings.channels.sa4c_vC1.enabled) enabledChannels.push(SA4C_CH_ENUM[0])
  if(tool.settings.channels.sa4c_vC2.enabled) enabledChannels.push(SA4C_CH_ENUM[1])
  if(tool.settings.channels.sa4c_vC3.enabled) enabledChannels.push(SA4C_CH_ENUM[2])
  if(tool.settings.channels.sa4c_vC4.enabled) enabledChannels.push(SA4C_CH_ENUM[3])
  return enabledChannels
}

export const SA4C_ENABLED_ARRAY = (tool, enabledChannels) =>{
  let enabledArray = []
  if(enabledChannels == null){
    enabledArray = [tool.settings.channels.sa4c_vC1.enabled,tool.settings.channels.sa4c_vC2.enabled,tool.settings.channels.sa4c_vC3.enabled,tool.settings.channels.sa4c_vC4.enabled,false]
  }else{
    enabledArray.push(_.find(enabledChannels, function(o) { return o == "sa4c_vC1" }) != undefined)
    enabledArray.push(_.find(enabledChannels, function(o) { return o == "sa4c_vC2" }) != undefined)
    enabledArray.push(_.find(enabledChannels, function(o) { return o == "sa4c_vC3" }) != undefined)
    enabledArray.push(_.find(enabledChannels, function(o) { return o == "sa4c_vC4" }) != undefined)
  }
  return enabledArray
}

export const SA4C_CONVERSION = (tool) =>{
  let convertedSensor = {}
  let ch1Unit = tool.settings.channels.sa4c_vC1.unit
  let ch2Unit = tool.settings.channels.sa4c_vC2.unit
  let ch3Unit = tool.settings.channels.sa4c_vC3.unit
  let ch4Unit = tool.settings.channels.sa4c_vC4.unit

  //Convert CH1
  if(tool.sensor.sa4c_vC1 == null){
    convertedSensor.sa4c_vC1 = null
  }else{
    if(ch1Unit == SA4C_CHANNELS.sa4c_vC1.unit.default || ch1Unit == SA4C_CHANNELS.sa4c_vC1.unit.enum[1] || tool.settings.channels.sa4c_vC1.linearScalingEnable){//Default mV or mA OR linear scaling
      convertedSensor.sa4c_vC1= tool.sensor.sa4c_vC1
    }else{//Conversion needed
      if(ch1Unit == SA4C_CHANNELS.sa4c_vC1.unit.enum[2]){//A
        convertedSensor.sa4c_vC1= tool.sensor.sa4c_vC1/1000
      }
    }
  }
  //Convert CH2
  if(tool.sensor.sa4c_vC2 == null){
    convertedSensor.sa4c_vC2 = null
  }else{
    if(ch2Unit == SA4C_CHANNELS.sa4c_vC2.unit.default || ch2Unit == SA4C_CHANNELS.sa4c_vC2.unit.enum[1] || tool.settings.channels.sa4c_vC2.linearScalingEnable){//Default mV or mA OR linear scaling
      convertedSensor.sa4c_vC2= tool.sensor.sa4c_vC2
    }else{//Conversion needed
      if(ch2Unit == SA4C_CHANNELS.sa4c_vC2.unit.enum[2]){//A
        convertedSensor.sa4c_vC2= tool.sensor.sa4c_vC2/1000
      }
    }
  }
  //Convert CH3
  if(tool.sensor.sa4c_vC3 == null){
    convertedSensor.sa4c_vC3 = null
  }else{
    if(ch3Unit == SA4C_CHANNELS.sa4c_vC3.unit.default || ch3Unit == SA4C_CHANNELS.sa4c_vC3.unit.enum[1] || tool.settings.channels.sa4c_vC3.linearScalingEnable){//Default mV or mA OR linear scaling
      convertedSensor.sa4c_vC3= tool.sensor.sa4c_vC3
    }else{//Conversion needed
      if(ch3Unit == SA4C_CHANNELS.sa4c_vC3.unit.enum[2]){//A
        convertedSensor.sa4c_vC3= tool.sensor.sa4c_vC3/1000
      }
    }
  }
  //Convert CH4
  if(tool.sensor.sa4c_vC4 == null){
    convertedSensor.sa4c_vC4 = null
  }else{
    if(ch4Unit == SA4C_CHANNELS.sa4c_vC4.unit.default || ch4Unit == SA4C_CHANNELS.sa4c_vC4.unit.enum[1] || tool.settings.channels.sa4c_vC4.linearScalingEnable){//Default mV or mA OR linear scaling
      convertedSensor.sa4c_vC4= tool.sensor.sa4c_vC4
    }else{//Conversion needed
      if(ch4Unit == SA4C_CHANNELS.sa4c_vC4.unit.enum[2]){//A
        convertedSensor.sa4c_vC4= tool.sensor.sa4c_vC4/1000
      }
    }
  }
  
  return convertedSensor
}

export const SA4C_GRAPH_CONVERSION = (tool,data,attributeArray) =>{
  let tempData = _.cloneDeep(data)
  let ch1Unit = tool.settings.channels.sa4c_vC1.unit
  let ch2Unit = tool.settings.channels.sa4c_vC2.unit
  let ch3Unit = tool.settings.channels.sa4c_vC3.unit
  let ch4Unit = tool.settings.channels.sa4c_vC4.unit
  let ch1Idx = _.findIndex(attributeArray,function(o) { return o == SA4C_CH_ENUM[0]})
  let ch2Idx = _.findIndex(attributeArray,function(o) { return o == SA4C_CH_ENUM[1]})
  let ch3Idx = _.findIndex(attributeArray,function(o) { return o == SA4C_CH_ENUM[2]})
  let ch4Idx = _.findIndex(attributeArray,function(o) { return o == SA4C_CH_ENUM[3]})

  tempData.forEach(dataPoint => {
    if(dataPoint[ch1Idx] != null && !tool.settings.channels.sa4c_vC1.linearScalingEnable){
      if(ch1Unit != SA4C_CHANNELS.sa4c_vC1.unit.default){//Default
        if(ch1Unit == SA4C_CHANNELS.sa4c_vC1.unit.enum[2]){//A
          dataPoint[ch1Idx] = dataPoint[ch1Idx]/1000
        }
      }
    }
    if(dataPoint[ch2Idx] != null && !tool.settings.channels.sa4c_vC1.linearScalingEnable){
      if(ch2Unit != SA4C_CHANNELS.sa4c_vC2.unit.default){//Default
        if(ch2Unit == SA4C_CHANNELS.sa4c_vC2.unit.enum[2]){//A
          dataPoint[ch2Idx] = dataPoint[ch2Idx]/1000
        }
      }
    }
    if(dataPoint[ch3Idx] != null && !tool.settings.channels.sa4c_vC1.linearScalingEnable){
      if(ch3Unit != SA4C_CHANNELS.sa4c_vC3.unit.default){//Default
        if(ch3Unit == SA4C_CHANNELS.sa4c_vC3.unit.enum[2]){//A
          dataPoint[ch3Idx] = dataPoint[ch3Idx]/1000
        }
      }
    }
    if(dataPoint[ch4Idx] != null && !tool.settings.channels.sa4c_vC1.linearScalingEnable){
      if(ch4Unit != SA4C_CHANNELS.sa4c_vC4.unit.default){//Default
        if(ch4Unit == SA4C_CHANNELS.sa4c_vC4.unit.enum[2]){//A
          dataPoint[ch4Idx] = dataPoint[ch4Idx]/1000
        }
      }
    }
  })
  return tempData
}

const SA4C_CHANNELS =
    {
        sa4c_vC1: {
            name: {type: "S", default: "Analog Channel 1"},
            sensorType: {type: "E", default: "Adapter 0-3.3V", enum: analogProbeType},
            unit: {type: "E", default: "mV", enum: ["mV", "mA", "V"], },
            enabled: {type: "B", default: true},
            driver: {type: "B", default: false},
            linearScalingAX: {type: "N", default: 0},
            linearScalingAY: {type: "N", default: 0},
            linearScalingBX: {type: "N", default: 0},
            linearScalingBY: {type: "N", default: 0},
            linearScalingEnable: {type: "B", default: false},
            linearScalingUnit: {type: "S", default: 'Unit'},
        },
        sa4c_vC2: {
            name: {type: "S", default: "Analog Channel 2"},
            sensorType: {type: "E", default: "Adapter 0-3.3V", enum: analogProbeType},
            unit: {type: "E", default: "mV", enum: ["mV", "mA", "V"], },
            enabled: {type: "B", default: true},
            driver: {type: "B", default: false},
            linearScalingAX: {type: "N", default: 0},
            linearScalingAY: {type: "N", default: 0},
            linearScalingBX: {type: "N", default: 0},
            linearScalingBY: {type: "N", default: 0},
            linearScalingEnable: {type: "B", default: false},
            linearScalingUnit: {type: "S", default: 'Unit'},
        },
        sa4c_vC3: {
            name: {type: "S", default: "Analog Channel 3"},
            sensorType: {type: "E", default: "Adapter 0-3.3V", enum: analogProbeType},
            unit: {type: "E", default: "mV", enum: ["mV", "mA", "V"], },
            enabled: {type: "B", default: true},
            driver: {type: "B", default: false},
            linearScalingAX: {type: "N", default: 0},
            linearScalingAY: {type: "N", default: 0},
            linearScalingBX: {type: "N", default: 0},
            linearScalingBY: {type: "N", default: 0},
            linearScalingEnable: {type: "B", default: false},
            linearScalingUnit: {type: "S", default: 'Unit'},
        },
        sa4c_vC4: {
            name: {type: "S", default: "Analog Channel 4"},
            sensorType: {type: "E", default: "Adapter 0-3.3V", enum: analogProbeType},
            unit: {type: "E", default: "mV", enum: ["mV", "mA", "V"], },
            enabled: {type: "B", default: true},
            driver: {type: "B", default: false},
            linearScalingAX: {type: "N", default: 0},
            linearScalingAY: {type: "N", default: 0},
            linearScalingBX: {type: "N", default: 0},
            linearScalingBY: {type: "N", default: 0},
            linearScalingEnable: {type: "B", default: false},
            linearScalingUnit: {type: "S", default: 'Unit'},
        },
    }

SA4C.ToolDashboardContainer = ({navigate,currentTool,selected}) => {
  let roundedVC1 = (currentTool.convertedSensor.sa4c_vC1 != "NC") ? Number(currentTool.convertedSensor.sa4c_vC1).toFixed(1) : "--"
  let roundedVC2 = (currentTool.convertedSensor.sa4c_vC2 != "NC") ? Number(currentTool.convertedSensor.sa4c_vC2).toFixed(1) : "--"
  let roundedVC3 = (currentTool.convertedSensor.sa4c_vC3 != "NC") ? Number(currentTool.convertedSensor.sa4c_vC3).toFixed(1) : "--"
  let roundedVC4 = (currentTool.convertedSensor.sa4c_vC4 != "NC") ? Number(currentTool.convertedSensor.sa4c_vC4).toFixed(1) : "--"  
  if(isNaN(roundedVC1)) roundedVC1 = "--"
  if(isNaN(roundedVC2)) roundedVC2 = "--"
  if(isNaN(roundedVC3)) roundedVC3 = "--"
  if(isNaN(roundedVC4)) roundedVC4 = "--"
  let onPress
  if(_.has(currentTool,'mac')){
    onPress = () => navigate(`/site/${currentTool.mac}`)
  }else{
    onPress = () => navigate(`/site/${currentTool.share_id}`)
  }
  let usbPowered = _.has(currentTool,'toolSystem') && !_.isEmpty(currentTool.toolSystem)?currentTool.toolSystem.sysPowerState == "USB":undefined
  let batteryLvl = _.has(currentTool,'toolSystem') && !_.isEmpty(currentTool.toolSystem) && currentTool.toolSystem.sysBatteryLvl?currentTool.toolSystem.sysBatteryLvl:undefined
  let cloudConnected = false
  if(_.has(currentTool,'nextUpdateTS')) cloudConnected = HelperService.isCloudConnected(currentTool.nextUpdateTS)
  return(
        <Dashboard.Overview
            title={currentTool.settings.toolName}
            description={"AnalogSense"}
            shared={!_.has(currentTool,'mac')}
            symbol={toolIcon}
            usbPowered = {usbPowered}
            batteryLvl = {batteryLvl}
            cloudConnected = {cloudConnected}
            onPress={onPress}
            alerts={currentTool.alerts}
            selected={selected}
            >
            {(_.has(currentTool, 'sensor') && !_.isEmpty(currentTool.sensor)) ? (
                <ViewRow>
                {currentTool.settings.channels.sa4c_vC1.enabled?(<Dashboard.Value style={styles.dashboardValue} value={roundedVC1} units={roundedVC1=="--"?"":currentTool.settings.channels.sa4c_vC1.linearScalingEnable?currentTool.settings.channels.sa4c_vC1.linearScalingUnit:currentTool.settings.channels.sa4c_vC1.unit} label={currentTool.settings.channels.sa4c_vC1.name} />):(<></>)}
                {currentTool.settings.channels.sa4c_vC2.enabled?(<Dashboard.Value style={styles.dashboardValue} value={roundedVC2} units={roundedVC2=="--"?"":currentTool.settings.channels.sa4c_vC2.linearScalingEnable?currentTool.settings.channels.sa4c_vC2.linearScalingUnit:currentTool.settings.channels.sa4c_vC2.unit} label={currentTool.settings.channels.sa4c_vC2.name} />):(<></>)}
                {currentTool.settings.channels.sa4c_vC3.enabled?(<Dashboard.Value style={styles.dashboardValue} value={roundedVC3} units={roundedVC3=="--"?"":currentTool.settings.channels.sa4c_vC3.linearScalingEnable?currentTool.settings.channels.sa4c_vC3.linearScalingUnit:currentTool.settings.channels.sa4c_vC3.unit} label={currentTool.settings.channels.sa4c_vC3.name} />):(<></>)}
                {currentTool.settings.channels.sa4c_vC4.enabled?(<Dashboard.Value style={styles.dashboardValue} value={roundedVC4} units={roundedVC4=="--"?"":currentTool.settings.channels.sa4c_vC4.linearScalingEnable?currentTool.settings.channels.sa4c_vC4.linearScalingUnit:currentTool.settings.channels.sa4c_vC4.unit} label={currentTool.settings.channels.sa4c_vC4.name} />):(<></>)}
                </ViewRow>
            ) : (
                <ViewRow>
                {currentTool.settings.channels.sa4c_vC1.enabled?(<Dashboard.Value style={styles.dashboardValue} value="--" units="" label={currentTool.settings.channels.sa4c_vC1.name} />):(<></>)}
                {currentTool.settings.channels.sa4c_vC2.enabled?(<Dashboard.Value style={styles.dashboardValue} value="--" units="" label={currentTool.settings.channels.sa4c_vC2.name} />):(<></>)}
                {currentTool.settings.channels.sa4c_vC3.enabled?(<Dashboard.Value style={styles.dashboardValue} value="--" units="" label={currentTool.settings.channels.sa4c_vC3.name} />):(<></>)}
                {currentTool.settings.channels.sa4c_vC4.enabled?(<Dashboard.Value style={styles.dashboardValue} value="--" units="" label={currentTool.settings.channels.sa4c_vC4.name} />):(<></>)}
                </ViewRow>
            )}
        </Dashboard.Overview>
    )
}

SA4C.OverviewContainer = ({ currentTool, stats, enabled, setEnabled }) => {
  let fontSize = "xxlarge"
  let roundedVC1 = (currentTool.convertedSensor.sa4c_vC1 != "NC") ? Number(currentTool.convertedSensor.sa4c_vC1).toFixed(1) : "--"
  let roundedVC2 = (currentTool.convertedSensor.sa4c_vC2 != "NC") ? Number(currentTool.convertedSensor.sa4c_vC2).toFixed(1) : "--"
  let roundedVC3 = (currentTool.convertedSensor.sa4c_vC3 != "NC") ? Number(currentTool.convertedSensor.sa4c_vC3).toFixed(1) : "--"
  let roundedVC4 = (currentTool.convertedSensor.sa4c_vC4 != "NC") ? Number(currentTool.convertedSensor.sa4c_vC4).toFixed(1) : "--" 
  if(isNaN(roundedVC1)) roundedVC1 = "--"
  if(isNaN(roundedVC2)) roundedVC2 = "--"
  if(isNaN(roundedVC3)) roundedVC3 = "--"
  if(isNaN(roundedVC4)) roundedVC4 = "--"
  const changeFontSize = () => {
    //xlarge 7-9 large 10, medium 11, 12-13 small, 14-15 hint
    if(roundedVC1.toString().length>=14 || roundedVC2.toString().length>=14 || roundedVC3.toString().length>=14 || roundedVC4.toString().length>=14){
      fontSize = "hint"
    } else if(roundedVC1.toString().length>11 || roundedVC2.toString().length>11 || roundedVC3.toString().length>11 || roundedVC4.toString().length>11){
      fontSize = "small"
    } else if(roundedVC1.toString().length>10 || roundedVC2.toString().length>10 || roundedVC3.toString().length>10 || roundedVC4.toString().length>10){
      fontSize = "medium"
    } else if(roundedVC1.toString().length>9 || roundedVC2.toString().length>9 || roundedVC3.toString().length>9 || roundedVC4.toString().length>9){
      fontSize = "large"
    } else if(roundedVC1.toString().length>6 || roundedVC2.toString().length>6 || roundedVC3.toString().length>6 || roundedVC4.toString().length>6){
      fontSize = "xlarge"
    } 
  } 
    return (
      <View >
        {(_.has(currentTool, 'sensor') && !_.isEmpty(currentTool.sensor)) ? (
          <View style={styles.dashboardView}>
            {changeFontSize()}
            {currentTool.settings.channels.sa4c_vC1.enabled?(<Dashboard.OverviewValue style={styles.overviewValue} size={fontSize} label={currentTool.settings.channels.sa4c_vC1.name} value={roundedVC1} units = {roundedVC1=="--"?"":currentTool.settings.channels.sa4c_vC1.linearScalingEnable?currentTool.settings.channels.sa4c_vC1.linearScalingUnit:currentTool.settings.channels.sa4c_vC1.unit} live={sensorLive.isLive(currentTool.sensor.updatedAt)} high={stats[0][0]!=null?stats[0][0].toFixed(1):"--"} low={stats[0][1]!=null?stats[0][1].toFixed(1):"--"} avg={stats[0][2]!=null?stats[0][2].toFixed(1):"--"} icon={ch1Icon} color={enabled[0] ? channelColors[0] : Colors.vlightGrey} enabled={enabled} setEnabled={setEnabled} index={0}/>):(<></>)}
            {currentTool.settings.channels.sa4c_vC2.enabled?(<Dashboard.OverviewValue style={styles.overviewValue} size={fontSize} label={currentTool.settings.channels.sa4c_vC2.name} value={roundedVC2} units = {roundedVC2=="--"?"":currentTool.settings.channels.sa4c_vC2.linearScalingEnable?currentTool.settings.channels.sa4c_vC2.linearScalingUnit:currentTool.settings.channels.sa4c_vC2.unit} live={sensorLive.isLive(currentTool.sensor.updatedAt)} high={stats[1][0]!=null?stats[1][0].toFixed(1):"--"} low={stats[1][1]!=null?stats[1][1].toFixed(1):"--"} avg={stats[1][2]!=null?stats[1][2].toFixed(1):"--"} icon={ch2Icon} color={enabled[1] ? channelColors[1] : Colors.vlightGrey} enabled={enabled} setEnabled={setEnabled} index={1}/>):(<></>)}
            {currentTool.settings.channels.sa4c_vC3.enabled?(<Dashboard.OverviewValue style={styles.overviewValue} size={fontSize} label={currentTool.settings.channels.sa4c_vC3.name} value={roundedVC3} units = {roundedVC3=="--"?"":currentTool.settings.channels.sa4c_vC3.linearScalingEnable?currentTool.settings.channels.sa4c_vC3.linearScalingUnit:currentTool.settings.channels.sa4c_vC3.unit} live={sensorLive.isLive(currentTool.sensor.updatedAt)} high={stats[2][0]!=null?stats[2][0].toFixed(1):"--"} low={stats[2][1]!=null?stats[2][1].toFixed(1):"--"} avg={stats[2][2]!=null?stats[2][2].toFixed(1):"--"} icon={ch3Icon} color={enabled[2] ? channelColors[2] : Colors.vlightGrey} enabled={enabled} setEnabled={setEnabled} index={2}/>):(<></>)}
            {currentTool.settings.channels.sa4c_vC4.enabled?(<Dashboard.OverviewValue style={styles.overviewValue} size={fontSize} label={currentTool.settings.channels.sa4c_vC4.name} value={roundedVC4} units = {roundedVC4=="--"?"":currentTool.settings.channels.sa4c_vC4.linearScalingEnable?currentTool.settings.channels.sa4c_vC4.linearScalingUnit:currentTool.settings.channels.sa4c_vC4.unit} live={sensorLive.isLive(currentTool.sensor.updatedAt)} high={stats[3][0]!=null?stats[3][0].toFixed(1):"--"} low={stats[3][1]!=null?stats[3][1].toFixed(1):"--"} avg={stats[3][2]!=null?stats[3][2].toFixed(1):"--"} icon={ch4Icon} color={enabled[3] ? channelColors[3] : Colors.vlightGrey} enabled={enabled} setEnabled={setEnabled} index={3}/>):(<></>)}
          </View>
        ):(<View style={styles.dashboardView}>
            {currentTool.settings.channels.sa4c_vC1.enabled?(<Dashboard.OverviewValue style={styles.overviewValue} size={fontSize} label={currentTool.settings.channels.sa4c_vC1.name} value="--" units="" live={false} low = "--" high = "--" avg = "--" icon={ch1Icon} color={enabled[0] ? channelColors[0] : Colors.vlightGrey} enabled={enabled} setEnabled={setEnabled} index={0}/>):(<></>)}
            {currentTool.settings.channels.sa4c_vC2.enabled?(<Dashboard.OverviewValue style={styles.overviewValue} size={fontSize} label={currentTool.settings.channels.sa4c_vC2.name} value="--" units="" live={false} low = "--" high = "--" avg = "--" icon={ch2Icon} color={enabled[1] ? channelColors[1] : Colors.vlightGrey} enabled={enabled} setEnabled={setEnabled} index={1}/>):(<></>)}
            {currentTool.settings.channels.sa4c_vC3.enabled?(<Dashboard.OverviewValue style={styles.overviewValue} size={fontSize} label={currentTool.settings.channels.sa4c_vC3.name} value="--" units="" live={false} low = "--" high = "--" avg = "--" icon={ch3Icon} color={enabled[2] ? channelColors[2] : Colors.vlightGrey} enabled={enabled} setEnabled={setEnabled} index={2}/>):(<></>)}
            {currentTool.settings.channels.sa4c_vC4.enabled?(<Dashboard.OverviewValue style={styles.overviewValue} size={fontSize} label={currentTool.settings.channels.sa4c_vC4.name} value="--" units="" live={false} low = "--" high = "--" avg = "--" icon={ch4Icon} color={enabled[3] ? channelColors[3] : Colors.vlightGrey} enabled={enabled} setEnabled={setEnabled} index={3}/>):(<></>)}
          </View>)}
      </View>
    )
}

export const SA4CChannelContainer = ({ currentTool, channelKey }) => {
  const [chError, setChError] = useState(true)
  const [allSites, setAllSites] = useRecoilState(allSitesAtom)
  const { user, signOut } = useAuthenticator((context) => [context.user]);
    // try {
      console.log("toolSettings:",currentTool.toolSettings)
      // const dispatch = useDispatch()
      // const { height, width } = useWindowDimensions();
      const units = SA4C_CHANNELS.sa4c_vC1.unit.enum
      const vUnits = ["mV","V"]
      const aUnits = ["mA"]
      const sensorTypes = analogProbeType
      const [chName, setChName] = useState(_.get(currentTool.settings.channels,channelKey).name)
      const [chEn, setChEn] = useState(_.get(currentTool.settings.channels,channelKey).enabled)
      const [chEnTool, setChEnTool] = useState(_.get(currentTool.toolSettings.channels,channelKey).enabled)
      const [chEnTime, setChEnTime] = useState(true)
      const [chDriver, setChDriver] = useState(_.get(currentTool.settings.channels,channelKey).driver)
      const [chDriverTool, setChDriverTool] = useState(_.get(currentTool.toolSettings.channels,channelKey).driver)
      const [chDriverTime, setChDriverTime] = useState(true)
      const [chUnit, setChUnit] = useState(_.get(currentTool.settings.channels,channelKey).unit)
      const [chSensorType, setChSensorType] = useState(_.get(currentTool.settings.channels,channelKey).sensorType)
      const [chSensorTypeTool, setChSensorTypeTool] = useState(_.get(currentTool.toolSettings.channels,channelKey).sensorType)
      const [chSensorTypeTime, setChSensorTypeTime] = useState(true)
      const [scalingEn, setScalingEn] = useState(_.get(currentTool.settings.channels,channelKey).linearScalingEnable)
      const [scalingEnTool, setScalingEnTool] = useState(_.get(currentTool.toolSettings.channels,channelKey).linearScalingEnable)
      const [scalingEnTime, setScalingEnTime] = useState(true)
      const [scalingAX, setScalingAX] = useState(_.get(currentTool.settings.channels,channelKey).linearScalingAX.toFixed())
      const [scalingAXTool, setScalingAXTool] = useState(_.get(currentTool.toolSettings.channels,channelKey).linearScalingAX.toFixed())
      const [scalingAXTime, setScalingAXTime] = useState(true)
      const [scalingAY, setScalingAY] = useState(_.get(currentTool.settings.channels,channelKey).linearScalingAY.toFixed())
      const [scalingAYTool, setScalingAYTool] = useState(_.get(currentTool.toolSettings.channels,channelKey).linearScalingAY.toFixed())
      const [scalingAYTime, setScalingAYTime] = useState(true)
      const [scalingBX, setScalingBX] = useState(_.get(currentTool.settings.channels,channelKey).linearScalingBX.toFixed())
      const [scalingBXTool, setScalingBXTool] = useState(_.get(currentTool.toolSettings.channels,channelKey).linearScalingBX.toFixed())
      const [scalingBXTime, setScalingBXTime] = useState(true)
      const [scalingBY, setScalingBY] = useState(_.get(currentTool.settings.channels,channelKey).linearScalingBY.toFixed())
      const [scalingBYTool, setScalingBYTool] = useState(_.get(currentTool.toolSettings.channels,channelKey).linearScalingBY.toFixed())
      const [scalingBYTime, setScalingBYTime] = useState(true)
      const [scalingUnit, setScalingUnit] = useState(_.get(currentTool.settings.channels,channelKey).linearScalingUnit)
      let graphData = allSites.graphData
      let index = _.indexOf(SA4C_CH_ENUM,channelKey)
      let tempGraphProps = currentTool.settings.graphPropsDashboard
      let tempChannels = _.cloneDeep(currentTool.settings.channels)

      useEffect(() => {
        console.log('Channel Key or Tool Changed!')
        setChName(_.get(currentTool.settings.channels,channelKey).name)
        setChEn(_.get(currentTool.settings.channels,channelKey).enabled)
        setChEnTime(true)
        setChUnit(_.get(currentTool.settings.channels,channelKey).unit)
        setChEnTool(_.get(currentTool.toolSettings.channels,channelKey).enabled)
        setChSensorType(_.get(currentTool.settings.channels,channelKey).sensorType)
        setChSensorTypeTool(_.get(currentTool.toolSettings.channels,channelKey).sensorType)
        setChDriver(_.get(currentTool.settings.channels,channelKey).driver)
        setScalingEn(_.get(currentTool.settings.channels,channelKey).linearScalingEnable)
        setScalingAX(_.get(currentTool.settings.channels,channelKey).linearScalingAX.toFixed())
        setScalingAY(_.get(currentTool.settings.channels,channelKey).linearScalingAY.toFixed())
        setScalingBX(_.get(currentTool.settings.channels,channelKey).linearScalingBX.toFixed())
        setScalingBY(_.get(currentTool.settings.channels,channelKey).linearScalingBY.toFixed())
        setChDriverTool(_.get(currentTool.toolSettings.channels,channelKey).driver)
        setScalingEnTool(_.get(currentTool.toolSettings.channels,channelKey).linearScalingEnable)
        setScalingAXTool(_.get(currentTool.toolSettings.channels,channelKey).linearScalingAX.toFixed())
        setScalingAYTool(_.get(currentTool.toolSettings.channels,channelKey).linearScalingAY.toFixed())
        setScalingBXTool(_.get(currentTool.toolSettings.channels,channelKey).linearScalingBX.toFixed())
        setScalingBYTool(_.get(currentTool.toolSettings.channels,channelKey).linearScalingBY.toFixed())
      }, [currentTool,channelKey]);
      function updateSettings(object,pullAfter) {
        updateToolSettings( currentTool, object).then(
          async()=> {
            if(pullAfter){
              await HelperService.delayMs(1000)
              getSettings(currentTool)
            }
          }
        )
      }
      async function getSettings(object) {
        console.log('updated Settings SDP1:',object)
        let settings = await getToolSettings(currentTool, object).then((settings) => settings)
        let tempAllSites = _.cloneDeepWith(allSites)
        let mac = currentTool?.mac?currentTool.mac:currentTool.share_id
        tempAllSites[mac].settings = settings.settings
        tempAllSites[mac].toolSettings = settings.toolSettings
        tempAllSites[mac].toolSystem = settings.toolSystem
        setAllSites(tempAllSites)
      }
          
      const chEnTimer = useRef(null)
      const chSensorTypeTimer = useRef(null)
      const  chDriverTimer = useRef(null)
      const scalingEnTimer = useRef(null)
      const scalingAXTimer = useRef(null)
      const scalingAYTimer = useRef(null)
      const scalingBXTimer = useRef(null)
      const scalingBYTimer = useRef(null)
      async function updateTime(timer,setTime) {
        clearTimeout(timer.current)
        timer.current = null
        setTime(false)
        timer.current = setTimeout(async() => {
          getSettings(currentTool)
          await HelperService.delayMs(1000)
          setTime(true)
        }, toolSyncTime-1000)
      }
    
      return (
        <View>
          <Row.Toggle //Enable/Disable
            title="Status"
            icon = {powerIcon}
            value={chEn}
            toolValue={chEnTool}
            syncTime={chEnTime}
            tool = {currentTool}
            getSettings = {getSettings}
            onValueChange={(value) => {
                setChEn(value)
                tempChannels[channelKey].enabled = value
                if(!_.isEmpty(tempGraphProps)) tempGraphProps.enY = SA4C_DEFAULT_Y_AXIS(tempChannels)
                updateSettings({ channels: { [channelKey]: { enabled: value } },graphPropsDashboard:tempGraphProps},false)
                updateTime(chEnTimer,setChEnTime)
                //UPDATE GRAPH DATA
                let tempGraphData = _.cloneDeep(graphData)
                tempGraphData.delete(currentTool.data_id) 
                // dispatch(ToolActions.addToolGraphDataToStore(tempGraphData,null,null))//Clear data
                //TODO reload data
            }}
          />
          <Row.Setting //Name
            title="Channel Name"
            icon = {SA4C_CHANNEL_ICONS[index]}
            color = {channelColors[index]}
            setting={chName}
            changeSetting={setChName}
            setSetting={() => updateSettings({ channels: { [channelKey]: { name: chName } } },true)}
          />
          {!scalingEn?<Row.Picker //Unit
            title="Unit"
            icon = {unitIcon}
            //4-20mA == 4
            values={chSensorType == sensorTypes[4]?aUnits:vUnits}
            value={chUnit}
            setValue={setChUnit}
            onPress={(value) => {
                setChUnit(value)
                tempChannels[channelKey].unit = value
                if(!_.isEmpty(tempGraphProps)) tempGraphProps.enY = SA4C_DEFAULT_Y_AXIS(tempChannels)
                updateSettings({ channels: { [channelKey]: { unit: value } },graphPropsDashboard:tempGraphProps },true)
                //UPDATE GRAPH DATA
                let tempGraphData = graphData
                tempGraphData.delete(currentTool.data_id) 
                // dispatch(ToolActions.addToolGraphDataToStore(tempGraphData,null,null))//Clear data
            }}
          />:<></>}
          <Row.Picker //SensorType
            title="Sensor Type"
            icon = {sensorIcon}
            values={sensorTypes}
            value={chSensorType}
            setValue={setChSensorType}
            toolValue={chSensorTypeTool}
            syncTime={chSensorTypeTime}
            tool = {currentTool}
            getSettings = {getSettings}
            onPress={(value) => {
              console.log('Sensor Type Value:',value)
                setChSensorType(value)
                setChUnit(value == sensorTypes[4]?aUnits[0]:vUnits[0])
                tempChannels[channelKey].unit = value == sensorTypes[4]?aUnits[0]:vUnits[0]
                tempChannels[channelKey].sensorType = value
                if(value == sensorTypes[4]) setChDriver(false)
                if(!_.isEmpty(tempGraphProps)) tempGraphProps.enY = SA4C_DEFAULT_Y_AXIS(tempChannels)
                if(value == sensorTypes[4]){
                  updateSettings({ channels: { [channelKey]: { sensorType: value, unit: aUnits[0], driver: false } },graphPropsDashboard:tempGraphProps },false)
                }else{
                  updateSettings({ channels: { [channelKey]: { sensorType: value, unit: vUnits[0] } },graphPropsDashboard:tempGraphProps },false)
                }
                updateTime(chSensorTypeTimer,setChSensorTypeTime)
            }}
          />
          {/* 4-20mA == 4 */}
          {chSensorType == sensorTypes[4]?<></>:<Row.Toggle //Driver
            title="Sensor Power"
            icon = {sensorPowerIcon}
            value={chDriver}
            toolValue={chDriverTool}
            syncTime={chDriverTime}
            tool = {currentTool}
            getSettings = {getSettings}
            onValueChange={(value) => {
                setChDriver(value)
                updateSettings({ channels: { [channelKey]: { driver: value } } },false)
                updateTime(chDriverTimer,setChDriverTime)
            }}
          >
            <View style={[Helpers.row]} gutter="none">
              <View style={styles.symbolContainer}>
                <Icon color={Colors.lightGrey} svg={infoIcon} size="xs" />
              </View>
              <View style={styles.container}>
                <Text color='lightGrey' as='small'>{"The 2.5 mm port can provide Power (3V, 10mA max) when sampling a sensor. This can eliminate the need for external voltage sources when using low power sensor."}</Text>
              </View>
            </View>
          </Row.Toggle>}
          <Row.Toggle //Linear Scaling
            title="Linear Scaling"
            icon = {scalingIcon}
            value={scalingEn}
            toolValue={scalingEnTool}
            syncTime={scalingEnTime}
            tool = {currentTool}
            getSettings = {getSettings}
            onValueChange={(value) => {
              setScalingEn(value)
              tempChannels[channelKey].linearScalingEnable = value
              tempChannels[channelKey].unit = tempChannels[channelKey].sensorType == sensorTypes[4]?aUnits[0]:vUnits[0]
              if(!_.isEmpty(tempGraphProps)) tempGraphProps.enY = SA4C_DEFAULT_Y_AXIS(tempChannels)
              updateSettings({ channels: { [channelKey]: { linearScalingEnable: value, unit: tempChannels[channelKey].unit } },graphPropsDashboard:tempGraphProps },false)
              updateTime(scalingEnTimer,setScalingEnTime)
              //UPDATE GRAPH DATA
              let tempGraphData = _.cloneDeep(graphData)
              tempGraphData.delete(currentTool.data_id) 
              // dispatch(ToolActions.addToolGraphDataToStore(tempGraphData,null,null))//Clear data
            }}>
              <View style={[Helpers.row]} gutter="none">
                <View style={styles.symbolContainer}>
                  <Icon color={Colors.lightGrey} svg={infoIcon} size="xs" />
                </View>
                <View style={styles.container}>
                  <Text color='lightGrey' as='small'>{"Linear Scaling converts raw value from a Channel to it's corresponding measurement value."}</Text>
                </View>
              </View>
          </Row.Toggle>
          {scalingEn?<Row.LinearScaling //Scaling settings
            ax= {scalingAX}
            axTool={scalingAXTool}
            axTime={scalingAXTime}
            changeAxTime={setScalingAXTime}
            changeAx= {setScalingAX} 
            setAx= {() => {
              updateSettings({ channels: { [channelKey]: { linearScalingAX: Number(scalingAX) } } },true)
              updateTime(scalingAXTimer,setScalingAXTime)
            }} 
            bx= {scalingBX} 
            bxTool={scalingBXTool}
            bxTime={scalingBXTime}
            changeBxTime={setScalingBXTime}
            changeBx= {setScalingBX} 
            setBx= {() => {
              updateSettings({ channels: { [channelKey]: { linearScalingBX: Number(scalingBX) } } },true)
              updateTime(scalingBXTimer,setScalingBXTime)
            }} 
            ay= {scalingAY} 
            ayTool={scalingAYTool}
            ayTime={scalingAYTime}
            changeAyTime={setScalingAYTime}
            changeAy= {setScalingAY} 
            setAy= {() => {
              updateSettings({ channels: { [channelKey]: { linearScalingAY: Number(scalingAY) } } },true)
              updateTime(scalingAYTimer,setScalingAYTime)
            }} 
            by= {scalingBY}
            byTool={scalingBYTool}
            byTime={scalingBYTime}
            changeByTime={setScalingBYTime}
            changeBy= {setScalingBY} 
            setBy= {() => {
              updateSettings({ channels: { [channelKey]: { linearScalingBY: Number(scalingBY) } } },true)
              updateTime(scalingBYTimer,setScalingBYTime)
            }}
            unit= {scalingUnit} 
            changeUnit= {setScalingUnit} 
            setUnit= {(value) => {
              tempChannels[channelKey].linearScalingUnit = value
              tempChannels[channelKey].unit = tempChannels[channelKey].sensorType == sensorTypes[4]?aUnits[0]:vUnits[0]
              if(!_.isEmpty(tempGraphProps)) tempGraphProps.enY = SA4C_DEFAULT_Y_AXIS(tempChannels)
              updateSettings({ channels: { [channelKey]: { linearScalingUnit: scalingUnit, unit: tempChannels[channelKey].unit } },graphPropsDashboard:tempGraphProps },true)
              //UPDATE GRAPH DATA
              let tempGraphData = _.cloneDeep(graphData)
              tempGraphData.delete(currentTool.data_id) 
              // dispatch(ToolActions.addToolGraphDataToStore(tempGraphData,null,null))//Clear data
            }}
            rawUnit= {tempChannels[channelKey].sensorType == sensorTypes[4]?aUnits[0]:vUnits[0]}
            tool = {currentTool}
          />:<></>}

          {scalingEn?<Graph.LinearScaling //Scaling settings
            index= {index}
            graphHeight ={112} 
            width={112}
            rawUnit= {tempChannels[channelKey].sensorType == sensorTypes[4]?aUnits[0]:vUnits[0]}
            ax= {scalingAX} 
            bx= {scalingBX} 
            ay= {scalingAY} 
            by= {scalingBY} 
            unit= {scalingUnit} 
          />:<></>}
        </View>
      )
    // } catch (error) {
    //   return(
    //     <View>
    //       <Alert visible={chError} setVisible={setChError} title="Error: Channel Setting Mismatch" 
    //       text={"Unable to display Tool's channel settings. Please update your Tool's firmware to resolve this issue."} oneButton={true}
    //       onPress={async ()=>{
    //         setChError(false)
    //       }}/>
    //     </View>
    //     )
    // }
  }

export default SA4C